import React, { useEffect, useState } from "react";
import "../../../css/VUP_dash.css";
import { FxValueDetail } from "./FxValueDetail"
import { FxmsData } from "../../datas/FxData";

export const FxMoChartPopup = (props) => {
  const [plantObj, setPlantObj] = useState({});
  const [dataObj, setDataObj] = useState({});

  useEffect(() => {
    if (props.selectedData) {
      let rowData = {};
      rowData = props?.selectedData;
      // console.log("rowData >>> ", rowData);

      const text = rowData?.dataText;
      const regex = /^([^\s]+)\s*\/\s*(.*)$/; // 공백이 아닌 문자열로 시작하고, /로 구분되며 앞뒤로 공백이 있을 수 있는 문자열 추출
      const match = text.match(regex);
      const moTid = match ? match[1] : "";
      const psName = match ? match[2].trim() : "";
      // console.log("■■■■■", moTid); // "F010004-HS1104A"
      // console.log("■■■■■", psName); // "공압기(드라이어) 공정 운전 스위치"

      rowData.moTid = moTid;
      rowData.psName = psName;
      rowData.moNo = parseInt(rowData?.parentNode?.dataId);

      setPlantObj({
        moTid: rowData.moTid,
        moNo: rowData.moNo,
        psId: rowData.dataId,
        psName: rowData.psName
      });
      getDataList(rowData.moNo);
    }
  }, [props.selectedData]);

  async function getDataList(moNo) {
    const param = { moNo: moNo };
    const uri = "fxMo/detail/base/"
    const response = await FxmsData.GET(uri.concat(param.moNo));
    console.log("response>>", response);
    // console.log("response.data>>", response.data[0]);
    setDataObj(response.data[0])
  }

  useEffect(() => {
  }, [plantObj, dataObj])

  return (
    <div className="popupBasic" style={{ border: "none" }}>
      <h1>관제점 상세보기</h1>
      <div className="default">
        <table className="align1c align3c">
          <colgroup>
            <col style={{ width: "8%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "16%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>명칭</th>
              <td>{plantObj.moTid}</td>
              <th>분류</th>
              <td>{dataObj.moClass}</td>
              <th>유형</th>
              <td>{dataObj.moType}</td>
              <th>관제점</th>
              <td>{plantObj.psName}</td>
            </tr>
          </thead>
        </table>

        <div className="factory_DataBox mngtg">
          {/* 탭 컴포넌트 */}
          <FxValueDetail datas={plantObj} />
        </div>
      </div>
    </div>
  );
}

